import React from 'react';
import { FlameIcon, MessagesSquareIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-navy px-4 py-6 text-center md:px-12 md:py-8" data-id="element-48" data-mp="87jrmejiieic">
      <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-gold md:text-[29px]" data-id="element-49" data-mp="m3drk82b5tjb">
        One final question...
      </h2>
      <div className="mx-auto mt-2 max-w-[580px] space-y-1.5 text-[14px] leading-[1.45] text-white md:text-[15px]" data-id="element-50" data-mp="vv1fhyznosg1">
        <p data-id="element-51" data-mp="qwzsj2z408za">
          How much time have you spent searching for AAC resources, creating therapy materials, and preparing
          documentation for every new communication challenge?
        </p>
        <p className="text-onNavyMuted" data-id="element-52" data-mp="zxo6jxoi69c6">
          You can keep building your collection one activity at a time — or have six volumes and five clinical toolkits
          organized in one place.
        </p>
      </div>
      <p className="mt-2 font-heading text-[13px] font-extrabold uppercase text-gold md:text-[14px]" data-id="element-53" data-mp="2h3zs05np4cns">
        Organize. Select. Adapt. Implement.
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-54" data-mp="2r277ek2c6mno">
        <ProductImage data-id="element-55" data-mp="2qzuhnkqc7802" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] font-heading text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[28px]" data-id="element-56" data-mp="2v4275k4mcrzc">
        <MessagesSquareIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-aqua" strokeWidth={2.5} aria-hidden data-id="element-57" data-mp="300iw2gjn7adh" />
        Complete AAC Communication Toolkit™
      </h3>
      <p className="mt-0.5 font-heading text-[13px] font-extrabold uppercase text-aqua md:text-[14px]" data-id="element-58" data-mp="39r3tw1rhsavc">
        The complete advanced AAC clinical resource collection
      </p>
      <p className="mx-auto mt-1 max-w-[600px] text-[13px] leading-[1.35] text-onNavyMuted md:text-[14px]" data-id="element-59" data-mp="3isbr0gi9v5nu">
        Functional AAC • Complex Language • Self-Advocacy • Alternative Access • Real-World Participation • Clinical
        Reasoning
      </p>
      <ul className="mt-1.5 space-y-0.5 font-heading text-[11px] font-bold uppercase text-white/85 md:text-[12px]" data-id="element-60" data-mp="1enfhe5sfcdx5">
        <li data-id="element-61" data-mp="1npyfkcl9m2d2">6 Professional Volumes + 5 FREE Bonuses</li>
        <li data-id="element-62" data-mp="1nodpp09wb7lj">390 Pages of Professional AAC Resources</li>
      </ul>
      <p className="mt-2.5 flex flex-wrap items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-gold md:text-[16px]" data-id="element-63" data-mp="22e1qm0e6048q">
        <FlameIcon className="h-4 w-4 shrink-0" strokeWidth={2.5} aria-hidden data-id="element-64" data-mp="2bfj1n4cptfqk" />
        Get the complete collection today for just {formatPrice(PRODUCT_PRICE)} USD!
      </p>
      <div className="mt-2.5" data-id="element-65" data-mp="27epi0n6b2n3h">
        <CtaButton mode="checkout" subtext={`Complete collection • ${formatPrice(PRODUCT_PRICE)} USD`} data-id="element-66" data-mp="h18dyz7uwrmd">
          Get instant access
        </CtaButton>
      </div>
      <p className="mt-2 text-[12px] font-semibold text-onNavyMuted md:text-[13px]" data-id="element-67" data-mp="d1psa187ocih">
        Instant Digital Access • Digital Delivery
      </p>
      {guaranteeEnabled && <p className="mx-auto mt-1.5 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-68" data-mp="6w9uup9arw15">
          <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-aqua" aria-hidden data-id="element-69" data-mp="3p9q3wtduoxkn" />
          7-day money-back guarantee • 6 volumes + 5 free bonuses
        </p>}
    </section>;
}